import Vue from 'vue';
const subscriptionMealEvent = new Vue();
export default subscriptionMealEvent;
